import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BrandLogo } from "@/components/BrandLogo";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-5">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
        <BrandLogo />
        {done ? (
          <div className="mt-8 text-center" data-testid="forgot-success">
            <MailCheck className="mx-auto h-12 w-12 text-green-600" />
            <h2 className="mt-4 font-display text-xl font-bold text-slate-900">Verifique seu e-mail</h2>
            <p className="mt-2 text-sm text-slate-500">
              Se o e-mail estiver cadastrado, enviamos um link para redefinir sua senha.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-blue-700 hover:underline">
              <ArrowLeft className="h-4 w-4" /> Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <h2 className="mt-8 font-display text-xl font-bold text-slate-900">Esqueceu sua senha?</h2>
            <p className="mt-1 text-sm text-slate-500">Informe seu e-mail e enviaremos um link de redefinição.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" data-testid="forgot-email-input" value={email}
                  onChange={(e) => setEmail(e.target.value)} required />
              </div>
              {error && <p className="text-sm text-red-600">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="h-11 w-full bg-blue-700 hover:bg-blue-800">
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Enviar link"}
              </Button>
            </form>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-blue-700 hover:underline">
              <ArrowLeft className="h-4 w-4" /> Voltar para o login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
